import type { EventListPageTypeString } from '~/composables/types/strapiEventListPage'
import { EventListPageType } from '~/composables/types/strapiEventListPage'
import { useEventListPageType } from '~/composables/transactionalPage/useEventListPageType'

interface EventListPageSlugs {
  pageType: EventListPageTypeString
  citySlug: string | undefined
  categorySlug: string
  generalSlug: string | undefined
  tagSlug: string | undefined
}

export const useEventListPageSlugs = (
  explicitPageType?: EventListPageTypeString
): EventListPageSlugs => {
  const route = useRoute()
  const { t } = useI18n()

  const pageType = explicitPageType ?? useEventListPageType()

  let citySlug: string | undefined = route?.params?.city?.toString()
  const categorySlug = route.params?.category?.toString() || ''
  let generalSlug = route.params?.slug?.toString()
  let tagSlug = generalSlug

  if (pageType === EventListPageType.TEAMEVENT) {
    const prefix = t('eventListPage.teamEventSlugPrefix')
    generalSlug = `${prefix}-${citySlug}`
    tagSlug = `${prefix}-${citySlug}`
    citySlug = undefined
  }

  return { pageType, citySlug, categorySlug, generalSlug, tagSlug }
}
